import { useCallback, useContext, useEffect, useState, VoidFunctionComponent } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { v4 as uuid4 } from 'uuid';
import { Notification } from './Notification';
import { NotificationContext } from './Notifications.context';
import { StyledNotifications } from './Notifications.styled';
import { NotificationData } from './types';

export const Notifications: VoidFunctionComponent = () => {
  const [notifications, setNotifications] = useState<Array<NotificationData>>([]);

  // Retrieve notification observable
  const notification$ = useContext(NotificationContext);

  /**
   * Handle notification close events
   *
   * @param {string} id Notification identifier
   */
  const handleNotificationClose = useCallback(
    (id: string) =>
      setNotifications(current => current.filter(notification => notification.id !== id)),
    [],
  );

  // Subscribe to the notifications
  useEffect(() => {
    const subscription = notification$.subscribe(notification => {
      setNotifications(current => [
        {
          ...notification,
          id: uuid4(),
        },
        ...current,
      ]);
    });

    // Unsubscribe from the observable when the component unmounts
    return () => subscription.unsubscribe();
  }, [notification$]);

  return (
    <StyledNotifications>
      <TransitionGroup component={null}>
        {notifications.map(data => (
          <Notification key={data.id} data={data} onClose={handleNotificationClose} />
        ))}
      </TransitionGroup>
    </StyledNotifications>
  );
};
